module.exports = __webpack_public_path__ + "img/topic1-2.5c6b139e.png";